import { Checkbox, Grid, MenuItem, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import FilterSelect from '../../../../../components/select/filterSelect'
import InputTextField from '../../../../../components/input/inputTextField'
import { useTranslation } from 'react-i18next';
import { handleTypingNumber } from '../../../../../utils/app.utils';
import { ButtonBack, ButtonPrimary } from '../../../../../components/button/ButtonCustoms';
import { swalActive, swalError, swalSuccess } from '../../../../../components/alert/swal';
import { OnlineCourseApi } from '../../../../../api/cms-online-course/online_course.api';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { dateToView } from '../../../../../utils/date.utils';
import OptionsButtonCustom from '../../../../../components/option-button/OptionsButtonCustom';
import { routeName } from '../../../../../routes/routeName';
import ModalCustom from '../../../../../components/modal/ModalCustom';
import AutocompleteSelect from '../../../../../components/select/autoCompleteSelect';
export default function CourseInfo(props: any) {
    const { form, setForm, getData, view } = props
    const navigate: NavigateFunction = useNavigate();
    const [open, setOpen] = useState<boolean>(false);
    const fileRef = useRef<any>()
    const { id } = useParams();
    const { t } = useTranslation();
    const [diploma, setDiploma] = useState<any[]>([])
    const [dataOnlineCourseoma, setDataOnlineCourse] = useState<any[]>([])
    const [dataCourse, setDataCourse] = useState<any>()

    const [tag, setTag] = useState<any[]>([])
    const [type, setType] = useState<any[]>([])
    const handleClose = async () => {
        setOpen(false)
    }
    const diplomaLiat = async () => {
        let condition: any = {
            page: 1,
            pageLimit: 100
        };

        const res = await OnlineCourseApi.listDiploma(condition);
        const data = res.data
        if (res.status < 300) {
            setDiploma(data?.data.items)
        }
    }
    const tagLiat = async () => {
        let condition: any = {
            page: 1,
            pageLimit: 100
        };

        const res = await OnlineCourseApi.listTag(condition);
        const data = res.data
        if (res.status < 300) {
            setTag(data?.data.items)
        }
    }
    const typeLiat = async () => {
        let condition: any = {
            page: 1,
            pageLimit: 100
        };

        const res = await OnlineCourseApi.listType(condition);
        const data = res.data
        if (res.status < 300) {
            setType(data?.data.items)
        }
    }
    const onlineCourseLiat = async () => {
        let condition: any = {
            page: 1,
            pageLimit: 100
        };

        const res = await OnlineCourseApi.list(condition);
        const data = res.data
        if (data?.status < 300) {
            setDataOnlineCourse(data?.data.items);

        }
    }
    useEffect(() => {
        diplomaLiat()
        tagLiat()
        typeLiat()
        onlineCourseLiat()
    }, [])
    const handleSubmit = async () => {
        const body = {
            online_course_no: form?.online_course_no || "",
            online_course_name: form?.online_course_name || "",
            online_course_teacher: form?.online_course_teacher || "",
            online_course_description: form?.online_course_description || "",
            online_course_lv: form?.online_course_lv || "",
            online_course_objective: form?.online_course_objective || "",
            online_course_suitable_for: form?.online_course_suitable_for || "",
            online_course_amount: form?.online_course_amount || 0,
            duration_hour: form?.duration_hour || 0,
            duration_minute: form?.duration_minute || 0,
            online_course_pay_within_day: form?.online_course_pay_within_day || 0,
            id_online_course_ref: form?.id_online_course_ref ? form?.id_online_course_ref?.join(', ') : "",
            id_online_course_type: form?.id_online_course_type || 0,
            id_online_course_diploma: form?.id_online_course_diploma || 0,
            id_online_course_tag: form?.id_online_course_tag ? form?.id_online_course_tag?.join(', ') : "",
            status_publish: "DRAFT",
            // status_publish: "PUBLISH",
            id_online_course_file_cover: form?.id_online_course_file_cover || 0
        }
        if (id) {
            await OnlineCourseApi.patch(body, id).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t("บันทึกคอร์สเรียน เรียบร้อยแล้ว"), undefined, undefined, () => {
                        getData()
                    })
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
            })

        } else {
            await OnlineCourseApi.post(body).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t("เพิ่มคอร์สเรียน เรียบร้อยแล้ว"), undefined, undefined, () => {
                        navigate(routeName.cms.OnlineCourseManagementDetail.replace(':id', res.data.data.id_online_course));
                    })
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
            })

        }
    }
    const onImageChange = async (event: any) => {
        if (event.target.files && event.target.files[0]) {
            const formData = new FormData();

            //DRAFT
            formData.append('file', event.target.files[0]);

            await OnlineCourseApi.fileCover(formData).then((res: any) => {
                if (res.status < 300) {
                    setForm({ ...form, id_online_course_file_cover: res.data.data.id_online_course_file, online_course_file_cover: res.data.data })
                    console.log(res.data);


                    // swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
            })

        }
    }
    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    return (
        <section className="my-4">
            <Grid container spacing={2}>
                <Grid item lg={8}>
                    <div style={{
                    }}>
                        <Grid container spacing={2}>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('รหัสคอร์สเรียน')}
                                    placeholder={t('รหัสคอร์สเรียน')}
                                    value={form?.online_course_no || ''}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, online_course_no: e.target.value })
                                    }}
                                    helperText={
                                        ""
                                    }
                                    disabled={view}
                                    required
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={9}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('ชื่อคอร์สเรียน')}
                                    placeholder={t('ชื่อคอร์สเรียน')}
                                    value={form?.online_course_name || ''}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, online_course_name: e.target.value })
                                    }}
                                    helperText={
                                        ""
                                    }
                                    disabled={view}
                                    required
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={4}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <FilterSelect
                                    value={form?.id_online_course_type || ""}
                                    heading={t('ประเภท')}
                                    labelId="year-id"
                                    selectId="year-select-id"
                                    options={type.map((item: any, index: number) => (
                                        <MenuItem value={item.id_online_course_type} key={index + 1}>
                                            {item.online_course_type}
                                        </MenuItem>
                                    ))}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, id_online_course_type: e.target.value })
                                    }}
                                    disabled={view}
                                    required
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={4}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <FilterSelect
                                    value={form?.id_online_course_tag || []}
                                    heading={t('แท็กที่เกี่ยวข้อง')}
                                    labelId="year-id"
                                    selectId="year-select-id"
                                    // renderValue={(selected) => {
                                    //     selected.join(', ')}}
                                    options={tag.map((item: any, index: number) => (
                                        <MenuItem value={item.id_online_course_tag} key={index + 1}>
                                            {/* <Checkbox checked={form?.id_online_course_tag.includes(item.id_online_course_tag)} /> */}
                                            {item.online_course_tag}
                                        </MenuItem>
                                    ))}
                                    multiple
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, id_online_course_tag: e.target.value })
                                    }}
                                    disabled={view}
                                    required
                                />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={4}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('ผู้สอน')}
                                    placeholder={t('ผู้สอน')}
                                    value={form?.online_course_teacher || ''}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, online_course_teacher: e.target.value })
                                    }}
                                    helperText={
                                        ""
                                    }
                                    disabled={view}
                                    required

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <FilterSelect
                                    value={form?.online_course_lv || ""}
                                    heading={t('ระดับเนื้อหา')}
                                    labelId="year-id"
                                    selectId="year-select-id"
                                    options={[
                                        {
                                            name: t("ระดับเบื้องต้น (Beginner)"),
                                            id: 'Beginner'
                                        },
                                        {
                                            name: t("ระดับกลาง (Intermediate)"),
                                            id: 'Intermediate'
                                        },
                                        {
                                            name: t("ระดับยาก (Advanced)"),
                                            id: 'Advanced'
                                        },
                                    ].map((item: any, index: number) => (
                                        <MenuItem value={item.name} key={index + 1}>
                                            {item.name}
                                        </MenuItem>
                                    ))}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, online_course_lv: e.target.value })
                                    }}
                                    disabled={view}
                                    required
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <FilterSelect
                                    value={form?.id_online_course_diploma || ""}
                                    heading={t('วุฒิบัตร')}
                                    labelId="year-id"
                                    selectId="year-select-id"
                                    options={diploma.map((item: any, index: number) => (
                                        <MenuItem value={item.id_online_course_diploma} key={index + 1}>
                                            {item.online_course_diploma}
                                        </MenuItem>
                                    ))}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, id_online_course_diploma: e.target.value })
                                    }}
                                    disabled={view}
                                    required
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('ชั่วโมง')}
                                    placeholder={t('ชั่วโมง')}
                                    value={form?.duration_hour || ''}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, duration_hour: e.target.value })
                                    }}
                                    helperText={
                                        ""
                                    }
                                    disabled={view}
                                    onkeypress={handleTypingNumber}
                                    required

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('นาที')}
                                    placeholder={t('นาที')}
                                    value={form?.duration_minute || ''}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, duration_minute: e.target.value })
                                    }}
                                    helperText={
                                        ""
                                    }
                                    onkeypress={handleTypingNumber}
                                    disabled={view}
                                    required

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={12}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('คำอธิบายหลักสูตร')}
                                    placeholder={t('คำอธิบายหลักสูตร')}
                                    value={form?.online_course_description || ''}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, online_course_description: e.target.value })
                                    }}
                                    helperText={
                                        ""
                                    }
                                    multiline
                                    minRow={3}
                                    inputHeight={'auto'}
                                    disabled={view}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={12}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('วัตถุประสงค์')}
                                    placeholder={t('วัตถุประสงค์')}
                                    value={form?.online_course_objective || ''}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, online_course_objective: e.target.value })
                                    }}
                                    helperText={
                                        ""
                                    }
                                    multiline
                                    minRow={4}
                                    inputHeight={'auto'}
                                    disabled={view}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={12}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('หลักสูตรนี้เหมาะสำหรับ')}
                                    placeholder={t('หลักสูตรนี้เหมาะสำหรับ')}
                                    value={form?.online_course_suitable_for || ''}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, online_course_suitable_for: e.target.value })
                                    }}
                                    multiline
                                    minRow={6}
                                    inputHeight={'auto'}
                                    disabled={view}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={12}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <Typography variant='h5' sx={{ fontWeight: "600" }}>{t("ข้อมูลการชำระเงิน")}</Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={6}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('ค่าธรรมเนียม (บาท)')}
                                    placeholder={t('ค่าธรรมเนียม (บาท)')}
                                    value={form?.online_course_amount || ''}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, online_course_amount: e.target.value })
                                    }}
                                    helperText={
                                        ""
                                    }
                                    onkeypress={handleTypingNumber}
                                    disabled={view}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={6}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('ชำระภายใน (จำนวนวัน)')}
                                    placeholder={t('ชำระภายใน (จำนวนวัน)')}
                                    value={form?.online_course_pay_within_day || ''}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, online_course_pay_within_day: e.target.value })
                                    }}
                                    helperText={
                                        ""
                                    }
                                    onkeypress={handleTypingNumber}
                                    disabled={view}

                                />
                            </Grid>

                        </Grid>
                    </div>
                </Grid>
                <Grid item lg={4}>
                    {!view && <ButtonPrimary
                        onClick={() => {
                            // swalActive('ยืนยันการชำระเงิน', 'ท่านต้องการยืนยันการชำระเงิน ใช่หรือไม่', () => {
                            //     swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
                            // }, 'info', 'ยืนยัน')
                            handleSubmit()
                        }}
                        mode="add"
                        buttonName={t("บันทึกข้อมูล")}
                        btnProps={{
                            width: "100%"
                        }}
                    />}
                    <div className='col-span-12 md:col-span-12  border-2 rounded-lg border-[#DDE1EB] relative h-auto my-[20px]'>
                        <div className="flex items-center gap-4 bg-[#DDE1EB] p-[10px] ">
                            {!view && <AddBoxIcon sx={{ color: '#0F9F0C', cursor: 'pointer' }} onClick={() => fileRef.current.click()} />}
                            <input ref={fileRef} className='hidden' type='file' accept={"image/*"} onChange={(e: any) => onImageChange(e)} />

                            <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{t("ภาพหน้าปก 1200 x 720 pixel")}</Typography>


                        </div>
                        {form?.online_course_file_cover &&
                            <div className='flex items-center justify-between p-[20px]'>
                                <div>
                                    <Typography>{form?.online_course_file_cover?.file_name}</Typography>
                                    <Typography>{formatBytes(form?.online_course_file_cover?.file_size)} {form?.online_course_file_cover?.created_date ? dateToView(form?.online_course_file_cover?.created_date) : '-'}</Typography>

                                </div>
                                <OptionsButtonCustom
                                    enableView
                                    enableDelete={!view}
                                    onViewClick={() => {
                                        window.open(process.env.REACT_APP_FILE_BASE_API + '/' + form?.online_course_file_cover?.file_path + form?.online_course_file_cover?.file_name, '_blank');

                                    }}


                                    onDeleteClick={() => {
                                        setForm({ ...form, id_online_course_file_cover: undefined, online_course_file_cover: undefined })

                                    }} />
                            </div>}
                    </div>
                    <div className='col-span-12 md:col-span-12  border-2 rounded-lg border-[#DDE1EB] relative h-[350px] mb-[20px]'>
                        <div className="flex items-center gap-4 bg-[#DDE1EB] p-[10px] ">
                            {!view && <AddBoxIcon sx={{ color: '#0F9F0C' }} onClick={() => {
                                setOpen(true)
                                setDataCourse(null)
                            }} />}
                            <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{t("หลักสูตรแนะนำก่อนเข้าเรียน")}</Typography>
                        </div>
                        {form?.online_course_ref?.map((item: any, index: number) => {
                            return (
                                <div className='flex items-center justify-between p-[10px]'>
                                    <div>
                                        <Typography>{item?.online_course_name}</Typography>

                                    </div>
                                    <OptionsButtonCustom
                                        enableDelete={!view}


                                        onDeleteClick={() => {
                                            setForm({ ...form, id_online_course_ref: form?.id_online_course_ref?.filter((x: any, i: number) => i !== index), online_course_ref: form?.online_course_ref?.filter((x: any, i: number) => i !== index) })

                                        }} />
                                </div>
                            )
                        })}
                    </div>

                </Grid>
            </Grid>
            <ModalCustom title={t('เพิ่มหลักสูตรแนะนำก่อนเข้าเรียน')} subTitle={t('กรุณาระบุรายละเอียด')} open={open} component={
                <div className='flex flex-col gap-4'>


                    <div>
                        <AutocompleteSelect
                            // heading={"ค้นหา รหัสคอร์สเรียน, ชื่อคอร์สเรียน"}
                            placeholder={t("ค้นหา รหัสคอร์สเรียน, ชื่อคอร์สเรียน")}
                            // freeSolo
                            labelId={"-"}
                            options={dataOnlineCourseoma || []}
                            // value={
                            //     ''
                            // }
                            getOptionLabel={(option: any) =>
                                `${option?.online_course_name}` || ""
                            }
                            renderOption={(props, option) => (
                                <li {...props}>{`${option?.online_course_name}`}</li>
                            )}
                            onChange={(e, value) => { setDataCourse(value) }}

                        // value={inputValue.adv_employee_id ?? null}
                        />
                    </div>

                    <div>
                        <InputTextField
                            heading={t("รหัสคอร์สเรียน")}
                            placeholder={t("-")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                            }}
                            value={dataCourse?.online_course_no || ''}
                            disabled
                        />
                    </div>
                    <div>
                        <InputTextField
                            heading={t("ชื่อคอร์สเรียน")}
                            placeholder={t("-")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                            }}
                            value={dataCourse?.online_course_name || ''}
                            disabled
                        />
                    </div>
                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleClose()
                            }}
                            buttonName={t("ยกเลิก")}
                        />
                        <ButtonPrimary
                            onClick={() => {
                                // handleCreate()

                                setForm({ ...form, id_online_course_ref: form?.id_online_course_ref?.length > 0 ? [...form?.id_online_course_ref, dataCourse?.id_online_course] : [dataCourse?.id_online_course], online_course_ref: form?.online_course_ref?.length > 0 ? [...form?.online_course_ref, dataCourse] : [dataCourse] })
                                setOpen(false)
                            }}
                            mode='add'
                            buttonName={t("ยืนยัน")}
                        />
                    </div>
                </div>
            } />
        </section>
    )
}
